// App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./components/layout";
import Home from "./pages/home";
import Wallet from "./pages/wallet";
import { createTheme, ThemeProvider } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, Arial, sans-serif",
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          {/* Wrap all the routes inside the Layout */}
          <Route path="/" element={<Layout />}>
            {/* Define routes that use the layout */}
            <Route index element={<Home />} />{" "}
            {/* Home will be the default route */}
            <Route path="wallet" element={<Wallet />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
